import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabGroupComponent } from './tab-group/tab-group.component';
import { TabContentComponent } from './tab-content/tab-content.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  imports: [CommonModule,FormsModule, ReactiveFormsModule],
  declarations: [TabGroupComponent, TabContentComponent],
  exports: [TabGroupComponent, TabContentComponent]
})
export class TabsModule {}
